import React, { Component } from 'react';
import _ from 'lodash';
// import pubsub from'pubsub-js';
// import $ from 'jquery';
// var str = "";
// var codes = ""va;

class FormElement extends Component {

    constructor(props) {
        super(props);
        this.state = {
            code: " ",
            autoIncrement: true,
            autoEnable: false
        }
        _.bindAll(this, ['onChangeIncrement','onChangeEnable', 'handleSubmit', 'handleNewTag']);
    }

    handleNewTag(e) {

    }

    handleSubmit(e) {
        e.preventDefault();
        var newTag = this.newTagInput.value;
        // console.log('new tag inside submit ',newTag)
        var tag = '';
        if(newTag.includes('M') || newTag.includes('B') || newTag.includes('P') || newTag.includes('C')|| newTag.includes('W')){
            console.log('not modified')
            tag = newTag;
        }else{
            tag = 'M'+newTag;
            console.log('modified tag is ',tag)
        }
        console.log('tag send to jar for writing ',tag)
        this.props.sock.send(tag);
        this.input.value = newTag;
        
        if(this.state.autoIncrement){
            var value = parseInt(newTag.substr(1)) + 1;                        
            console.log(value);
            var currentTag = newTag[0]+value;
            this.newTagInput.value = currentTag; 
        }
    }
    // componentWillReceiveProps(nextProps) {
    //     if (nextProps.myProp !== this.props.myProps) {
    //         console.log(nextProps.props);
    //     }
    //     else {
    //         console.log('purana wala hi ' + this.props.code)
    //     }
    // }

    onChangeIncrement(e) {

        this.setState({autoIncrement:!this.state.autoIncrement})
        // this.setState(prevState => {
        //     prevState.autoIncrement = !prevState.autoIncrement;
        // });
    }

    onChangeEnable(e){
        
        this.setState({autoEnable:!this.state.autoEnable});
    }


    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <label>Current Tag
                    <input type="text" id="setMe" value={this.props.code}
                        ref={(input) => { this.input = input }}
                        style={{ marginLeft: 30, backgroundColor: 'lightgreen' }} readOnly />
                </label>
                <br />

                <label>Auto Increment</label>
                <input
                    type="checkbox"
                    checked={this.state.autoIncrement}
                    onChange={this.onChangeIncrement} />

                <label style={{ marginLeft: 10 }}>Auto read enable</label>
                <input
                    type="checkbox"
                    onChange={this.onChangeEnable}
                    checked={this.state.autoEnable} />
                <br />

                <label>New Tag
                    <input
                        type="text"
                        ref={(input) => { this.newTagInput = input }}
                        style={{ marginLeft: 50 }}
                        onChange={this.handleNewTag} />
                </label>

                <br />

                <div className=" btngroup btn-toolbar">
                    <button style = {{marginRight : 10}} className="btn " type="submit">Write</button>
                    <button style = {{marginRight : 10}} className="btn " type="button" >Refresh</button>
                </div>
            </form>
        )
    }
}

export default FormElement;


// WEBPACK FOOTER //
// ./src/Components/Tag Writer/FormElement.js